import http_multipart from "@/http-multipart";
import httpCommon from "@/http-common";

class TextEditorTeacherService {
    addImageInPost(formData) {
        return http_multipart.post("/notify-teacher/add_image", formData);
    }

    removeImagePost(id) {
        return httpCommon.delete("/notify-teacher/remove_image", {
            params: {
                id: id
            }
        });
    }

    removeMultiImagePost(ids) {
        return httpCommon.delete("/notify-teacher/remove_multi_image", {
            data: ids
        });
    }

    setDelActiveImage(imageDelete, imageAdd) {
        return httpCommon.put("/notify-teacher/active", {
            imageAdd: imageAdd,
            imageDelete: imageDelete
        })
    }
}

export default new TextEditorTeacherService();
